/*
  Must match the breakpoints defined in responsive.scss
*/

export const BREAKPOINTS = {
  SMALL: 728,
  MEDIUM: 1024,
}
